module.exports = __webpack_public_path__ + "static/media/page-6.eff8c020.png";